import React from 'react';
import { shouldIndentBullet } from '../../helpers/filtersAndHelpers';
import { replaceTemplateTags } from '../../helpers/replaceTemplateTags';
import './styling.css';

function splitBullets(text) {
  // Split on bullet character or newline, trim, and filter out empty
  const bullets = text
    .split(/•|\n/)
    .map((b) => b.trim())
    .filter((b) => b.length > 0);
  return bullets;
}

function BulletComponent({ question, parentQuestion, branchMetadata }) {
  const rawText = question.Text || '';
  // Replace template tags before splitting into bullets
  const processedText = replaceTemplateTags(rawText, branchMetadata || {});
  const bullets = splitBullets(processedText);
  const indent = shouldIndentBullet(question, parentQuestion);
  return (
    <ul
      className={`shared-padding bullet-component${indent ? ' bullet-indent' : ''}`}
      style={{ marginBottom: '0.5em' }}
    >
      {bullets.map((bullet, idx) => (
        <li key={idx}>{bullet}</li>
      ))}
    </ul>
  );
}

export default BulletComponent;
